import script from "./NewsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsView.vue?vue&type=script&setup=true&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=538f6542&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538f6542"]])

export default __exports__